import { useNavigate } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import { Button } from '@/common/components/Button.tsx'
import { ClockIcon } from '@/common/icons/general.tsx'

const PaymentAppealSuccess = () => {
  const navigate = useNavigate()


  return  (

    <div className='max-w-lg mx-auto'>

    <FamilyWizardLayout > 
      <FamilyWizardLayout.Header>
        <h1 className="text-3xl font-medium text-gray-900">
          Payment Appeal sent successfully
        </h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="items-center justify-center">
        <ClockIcon className="text-7xl text-primary mb-7"/>
        <h2 className="text-xl font-medium text-center text-gray-800 mb-8">
          Your request is under review.
        </h2>
      </FamilyWizardLayout.Content>

      <Card className="w-full flex-shrink-0">
        <CardHeader className="flex items-center sm:px-3 justify-between">
          <h3 className="font-medium text-md">
            Information
          </h3>
        </CardHeader>

        <CardContent className="w-full">
          <ul>
            <li className="flex items-center justify-between py-2">
              <span className="text-neutral-700">Application Status</span>
              <span className="text-neutral-900 font-medium">Under Review</span>
            </li>
            <li className="flex items-center justify-between py-2">
              <span className="text-neutral-700">Processing Time</span>
              <span className="text-neutral-900 font-medium">
                  Within 24 Hours
                </span>
            </li>
          </ul>
        </CardContent>
      </Card>
      <FamilyWizardLayout.ActionBar>
        <Button
          className="w-full"
          size="xl"
          onClick={() => { 
            navigate(AppRoutePaths.payments.index)
          }}
          >
          Continue
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
          </div>
  )
}
export default PaymentAppealSuccess;
